// Copy for /apply/<code> pages. One template for every job: the job title
// comes from the apply link (same value as the "You are applying for" chip),
// and client specifics stay in the JD drawer, never here.
// /join keeps its own designer-signup copy in the components.

export const applyHeading = (jobTitle: string) => `Apply for ${jobTitle}`;

export const APPLY_MOBILE_HEADING = "Apply for this role";

export const APPLY_BODY =
  "We're recruiting this role for a client. Our founder, Guidione, will review your application by hand for this specific hire. Completing this form applies you to this job only.";

export const APPLY_PROGRESS_LABEL = "Application progress";

export const APPLY_SUBMIT_LABEL = "Submit application";

// Talent-pool framing got a LinkedIn job ad rejected. Never reintroduce these
// in apply-page copy (guarded by scripts/apply-copy.test.ts).
export const BANNED_APPLY_PHRASES = [
  "talent pool",
  "pool I hire from",
  "pool we hire from",
  "searches I run",
  "searches we run",
  "join our designer network",
  "add your profile so you're in that set",
  "get in front of the searches",
];
